'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const UserSettingsStateNames=[
'notificationSettings',
'timelineSettings',
'groups',
'profile',
'organizationProfile',
'organizationUsers',
'terms'].
map(featureSubPath=>`fdc.features.${featureSubPath}`);let

UserSettingsButtonDirective=class UserSettingsButtonDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/userSettingsButtonDirective/userSettingsButtonTemplate'}

get controller(){return UserSettingsButtonDirectiveController}};let


UserSettingsButtonDirectiveController=class UserSettingsButtonDirectiveController{
constructor($scope,$state,$timeout,userService,breadcrumbsService,fatigueMeterTypeContentProviderService){
this._$scope=$scope;
this._$state=$state;
this._$timeout=$timeout;
this._userService=userService;
this._breadcrumbsService=breadcrumbsService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
this._isHidden=!0;

this._$scope.$watch('controller._userService.currentUser',()=>this._setUserInfo());
this._setUserInfo();

this._$scope.$watch('controller._$state.current.name',()=>this._refreshButtonState());
this._refreshButtonState();
}

logout(){
this._$timeout(()=>{
this._userService.logout();
this._unsetUserInfo();
});
}

_setUserInfo(){
this._$timeout(()=>{
if(_.exists(this._userService,'currentUser.firstName')&&
_.exists(this._userService,'currentUser.lastName')){
const currentUser=this._userService.currentUser;
this._firstName=currentUser.firstName;
this._lastName=currentUser.lastName;
this._isHidden=!1;
return;
}

this._unsetUserInfo();
});
}

_unsetUserInfo(){
this._firstName=void 0;
this._lastName=void 0;
this._isHidden=!0;
this._breadcrumbsService.clearCrumbsAndResetWindowTitle();
}

_refreshButtonState(){
this._isInUserSettingsSubState=_(UserSettingsStateNames).includes(this._$state.current.name);
}

get isHidden(){
return this._isHidden;
}

get firstName(){
return this._firstName;
}

get lastName(){
return this._lastName;
}

get isInUserSettingsSubState(){
return this._isInUserSettingsSubState;
}

get hideProfile(){
return this._fatigueMeterTypeContentProviderService.hideProfile;
}};



module.exports=UserSettingsButtonDirective;
//# sourceMappingURL=userSettingsButtonDirective.js.map
